import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { CoordinatorService } from '../../../core/services/coordinator/coordinator.service'
import { CreateCoordinatorModel } from '../../../core/models/coordinator.model'

@Component({
  selector: 'coordinator-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
    NgxMaskDirective,
  ],
  templateUrl: './coordinator-create.component.html',
  styleUrl: './coordinator-create.component.scss',
  providers: [CoordinatorService, provideNgxMask({ dropSpecialCharacters: false })],
  standalone: true,
})
export class CoordinatorCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private coordenadorService: CoordinatorService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.coordenadorService.createCoordenador(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel(): CreateCoordinatorModel {
    return {
      nome: this.form.controls['nome'].value,
      contato: this.form.controls['contato'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      nome: ['', [Validators.required]],
      contato: ['', [Validators.required]],
    })
  }
}
